import { useMediaQuery } from "@material-ui/core";
import React, { useState, useEffect } from "react";

export const useDeviceDetector = () => {
  // const [isMobile, setMobile] = useState(false);
  const isTablet = useMediaQuery('(max-width: 768px)');
  const isMobile = useMediaQuery('(max-width: 425px)');

  // useEffect(() => {
  //   const userAgent =
  //     typeof window.navigator === "undefined" ? "" : navigator.userAgent;
  //   const mobile = Boolean(
  //     userAgent.match(
  //       /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
  //     )
  //   );
  //   setMobile(mobile);
  // }, []);

  const isRunningLocally = window.location.href.includes('localhost')

  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  // Android WebViews tag the UA with "; wv)" — used to avoid promoting the
  // Play Store app when the page is already embedded inside the native app.
  const isInAppWebView = isAndroid && /;\s*wv\b/i.test(userAgent);
  // iOS WKWebViews omit the "Safari" token that real Safari always carries —
  // used to avoid promoting the App Store app inside the native iOS app.
  const isIOSWebView = isIOS && !/Safari/i.test(userAgent);

  return { isMobile, isTablet, isRunningLocally, isAndroid, isIOS, isInAppWebView, isIOSWebView };
}